// extracted by mini-css-extract-plugin
module.exports = {"container":"UnauthorizedApp__container___2Kxae","content":"UnauthorizedApp__content___lokhx"};